import giftImage from "../../images/gifts.jpg";
import cakeImage from "../../images/cake.jpg";
import flowerImage from "../../images/flower.jpg";

const services = [
    {
        id: "one-time-service",
        title: "One-Time Service",
        description: "Deliver gifts, cakes, flowers, or groceries for special occasions.",
        details: "With our One-Time Service, you can send thoughtful gifts, delicious cakes, or essential items like groceries to your loved ones in India.",
        image: giftImage,
        features: [
            "Personalized gifting options",
            "Fast and reliable delivery",
            "Flexible customization options",
        ],
    },
    {
        id: "one-day-service",
        title: "One-Day Service",
        description: "Make a special day extraordinary with curated meals and surprises.",
        details: "The One-Day Service is designed to create memorable experiences for your loved ones in India.",
        image: flowerImage,
        features: [
            "Curated meal planning",
            "Celebration setups",
            "Custom surprises tailored to preferences",
        ],
    },
    {
        id: "one-month-service",
        title: "One-Month Service",
        description: "Provide ongoing support for elderly parents with groceries, medicines, and daily needs.",
        details: "With our One-Month Service, we assist elderly parents or loved ones with essential needs like groceries, medicines, and more.",
        image: cakeImage,
        features: [
            "Groceries and medicines delivery",
            "Dedicated support team",
            "Flexible subscription options",
        ],
    },
];

export default services;
